module.exports = __webpack_public_path__ + "static/img/pico23.0dda68c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico23.png
// module id = bHLH
// module chunks = 0